/* @flow */
import { navTabElevation } from 'src/shared/app/base/style/token/elevation';

export default {
  root: {
    position: 'fixed',
    top: '30%',
    right: 0,
    zIndex: navTabElevation,
    '& > *': {
      marginBottom: '0.5em',
    },
  },
  item: {
    textAlign: 'right',
  },
};
